/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiDocument } from '../../models/AaiDocument';
import { AaiServer } from '../../models/AaiServer';
import { Constants } from '../../../core/Constants';
import { Document } from '../../../core/models/Document';
import { DocumentType } from '../../../core/models/DocumentType';

/**
 * Constructor.
 * @class
 * @extends AaiDocument
 * @author eric.wittmann@gmail.com
 */
export class Aai20Document extends AaiDocument {
    public constructor() {
        super();
        this.asyncapi = Constants.ASYNC_API_20_DEFAULT_VERSION;
    }

    /**
     * @see Document#getDocumentType()
     * @return {DocumentType}
     */
    public getDocumentType() : DocumentType {
        return DocumentType.asyncapi2;
    }

    /**
     * @see Document#createInfo()
     * @return {Aai20Info}
     */
    public createInfo() : Aai20Info {
        return new Aai20Info(this);
    }

    /**
     * @see Document#createTag()
     * @return {Aai20Tag}
     */
    public createTag() : Aai20Tag {
        return new Aai20Tag(this);
    }

    /**
     * @see Document#createExternalDocumentation()
     * @return {Aai20ExternalDocumentation}
     */
    public createExternalDocumentation() : Aai20ExternalDocumentation {
        return new Aai20ExternalDocumentation(this);
    }

    public createServer$java_lang_String(name : string) : AaiServer {
        return new Aai20Server(this, name);
    }

    public createServer$java_lang_String$java_lang_String$java_lang_String(name : string, url : string, description : string) : AaiServer {
        let server : Aai20Server = new Aai20Server(this, name);
        server.url = url;
        server.description = description;
        return server;
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.models.AaiDocument#createServer(java.lang.String, java.lang.String, java.lang.String)
     * @param {string} name
     * @param {string} url
     * @param {string} description
     * @return {AaiServer}
     */
    public createServer(name? : any, url? : any, description? : any) : any {
        if(((typeof name === 'string') || name === null) && ((typeof url === 'string') || url === null) && ((typeof description === 'string') || description === null)) {
            return <any>this.createServer$java_lang_String$java_lang_String$java_lang_String(name, url, description);
        } else if(((typeof name === 'string') || name === null) && url === undefined && description === undefined) {
            return <any>this.createServer$java_lang_String(name);
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {string} name
     * @return {Aai20ChannelItem}
     */
    public createChannelItem(name : string) : Aai20ChannelItem {
        return new Aai20ChannelItem(this, name);
    }

    /**
     * 
     * @return {Aai20Components}
     */
    public createComponents() : Aai20Components {
        return new Aai20Components(this);
    }
}
Aai20Document["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20Document";
Aai20Document["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { Aai20Components } from './Aai20Components';


import { Aai20ChannelItem } from './Aai20ChannelItem';


import { Aai20Server } from './Aai20Server';


import { Aai20ExternalDocumentation } from './Aai20ExternalDocumentation';


import { Aai20Tag } from './Aai20Tag';


import { Aai20Info } from './Aai20Info';

